<!--
    @不参与审核的领导首页-项目跟踪-步骤流程
-->
<template>
	<div class="leader_step">
		<div class="item" :class="classFn(item)" v-for="(item,i) in data" :key="i">
			<span class="my_icon"></span>
			<em>{{item.name}}</em>
		</div>
	</div>
</template>

<script>
export default {
	props:{
		data:{
			type:Array,
			default:function(){
				return [];
			}
		},
		buyprojectState:{
			type:Number,
			default:0
		}
	},
	data(){
		return{}
	},
	methods:{
		classFn(item){
			let temp=this.getMax();
			if(item.completeState && (item.projectState<temp)){
				return 'step_pass';
			}else if(item.completeState && (item.projectState==temp)){
				return 'step_ing';
			}else{
				return null;
			}
		},
		// 获取completeState为ture的projectState最大值
		getMax(){
			let max = this.data[0].projectState;
			for (let i = 0; i < this.data.length-1; i++) {
				if(this.data[i+1].completeState){
					max = Number(max) < Number(this.data[i+1].projectState) ? Number(this.data[i+1].projectState) : Number(max);
				}
			}
			return max;
		}
	}
}
</script>

<style lang="less" scoped>
.leader_step{
	width: 100%;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
	padding: 10px 20px 30px 20px;
	.item{
		width: 80px;
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;
		border-bottom: 1px solid #A6A6A6;
		z-index: 1;
		margin: 0 7px;
		&:first-child{
			width: 1px;
		}
		.my_icon{
			display: inline-block;
			width: 16px;
			height: 16px;
			text-align: center;
			line-height: 16px;
			border: 1px solid #A6A6A6;
			border-radius: 50%;
			z-index: 9999;
			position: absolute;
			bottom: -8px;
			right: -15px;
		}
		em{
			font-style: normal;
			position: absolute;
			bottom: -30px;
			right: -45px;
			width: 80px;
			text-align: center;
			color: #A6A6A6;
		}
	}
	@media screen and (max-width: 1366px){
		.item{
			width: 60px;
		}
	}
	.step_pass{
		border-bottom-color: #1965FF;
		.my_icon{
			border-color: #1965FF;
		}
	}
	.step_ing{
		border-bottom-color: #1965FF;
		.my_icon{
			border-color: #1965FF;
			background: #1965FF;
		}
	}
}
</style>
